/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import { Tooltip } from 'antd';
import { useMap } from 'react-leaflet';
import { useMapContext } from '../context/map-context';
import { IRecordMap } from '../../../../store/modules/report/i-report';
import capitalize from '../../../../utils/capitalize';
import { AssetIcon } from '../../../lib/asset-icon/AssetIcon';
import './styles.css';

interface IProps {
  marker:IRecordMap
}
export const PinPopup:React.FC<IProps> = ({ marker }) => {
  const {
    onShowAssetDetails, selectedPin, configurationValues, selectedPinIconUrl,
  } = useMapContext();
  const { popupFields } = configurationValues;
  const map = useMap();
  const pinRecord = (selectedPin ?? {}) as unknown as Record<string, string>;
  const customRows = popupFields === undefined ? null
    : popupFields
      .filter((key) => key !== 'uniqueKey' && key in pinRecord)
      .map((key) => [key, pinRecord[key]] as [string, string]);
  const isOpenPopup = selectedPin?.uniqueKey === marker.uniqueKey;
  const rowCount = customRows?.length ?? 0;

  useEffect(() => {
    if (!isOpenPopup) return;
    // eslint-disable-next-line no-underscore-dangle, @typescript-eslint/no-explicit-any
    (map as any)._popup?.update();
  }, [isOpenPopup, rowCount, map]);

  return (
    <div style={{
      borderRadius: '10px',
      width: '300px',
      overflow: 'hidden',
      boxShadow: '0px 16px 44px 0px rgba(0, 0, 0, 0.18), 0px 2px 26px 0px rgba(0, 0, 0, 0.19), 0px 0px 1px 0px rgba(0, 0, 0, 0.12)',
    }}
    >
      <div style={{
        padding: '16px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
        backgroundColor: '#F1F2F5',
      }}
      >
        <AssetIcon src={selectedPinIconUrl} />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          flex: 1,
          minWidth: 0,
        }}
        >
          {selectedPin?.color && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <div style={{
                height: '10px', width: '10px', borderRadius: '50%', backgroundColor: `${selectedPin.color}`,
              }}
              />
              <span style={{ whiteSpace: 'nowrap', fontSize: '10px' }}>GOOD CONDITION</span>
            </div>
          )}
          {selectedPin?.Time && (
            <div style={{
              fontSize: '13px',
              color: '#4E4F52',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            >
              {selectedPin.Time}
            </div>
          )}
        </div>
      </div>
      {customRows === null && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
          padding: '16px',
        }}
        >

          <div style={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              fontSize: '12px',
              color: '#81848C',
              gap: '8px',
            }}
            >
              <span style={{ height: '15px' }}>EUID: </span>
              <span style={{ height: '15px' }}>Zone:</span>
              <span style={{ height: '15px' }}>X: </span>
              <span style={{ height: '15px' }}>Y: </span>
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              fontSize: '12px',
              color: '#4E4F52',
              gap: '8px',
            }}
            >
              <Tooltip title={selectedPin?.EPC || selectedPin?.UID || ''}>
                <span style={{
                  color: '#292121',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  height: '15px',
                  maxWidth: '200px',
                }}
                >
                  {selectedPin?.EPC || selectedPin?.UID || ''}
                </span>
              </Tooltip>
              <Tooltip title={selectedPin?.Zone || ''}>
                <span style={{
                  color: '#292121',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  height: '15px',
                  maxWidth: '200px',
                }}
                >
                  {selectedPin?.Zone || ''}
                </span>
              </Tooltip>

              <span style={{ height: '15px' }}>{selectedPin?.X || selectedPin?.x || ''}</span>
              <span style={{ height: '15px' }}>{selectedPin?.Y || selectedPin?.y || ''}</span>
            </div>
          </div>

        </div>
      )}
      {customRows && customRows.length > 0 && (
        <div
          className="pin-popup-fields-scroll"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            backgroundColor: 'white',
            padding: '16px',
            maxHeight: '320px',
            overflowY: 'auto',
          }}
        >
          {customRows.map(([key, value]) => (
            <div key={key} style={{ display: 'flex', flexDirection: 'row', fontSize: '12px' }}>
              <span style={{ color: '#81848C', width: '80px', flexShrink: 0 }}>
                {capitalize(key)}
                :
              </span>
              <Tooltip title={value}>
                <span style={{
                  color: '#292121',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '190px',
                }}
                >
                  {value}
                </span>
              </Tooltip>
            </div>
          ))}
        </div>
      )}
      <div
        onClick={() => onShowAssetDetails(selectedPin)}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '5px 16px 16px',
          background: 'white',
          cursor: 'pointer',
        }}
      >
        <span style={{ color: '#3800EE' }}>See all information</span>
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.33335 8.96487L12.6667 8.96487" stroke="#3800EE" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8.00002 4.29821L12.6667 8.96488L8.00002 13.6315" stroke="#3800EE" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

      </div>
    </div>
  );
};
